if (!customElements.get('shop-the-look-component')) {
  class ShopTheLookComponent extends HTMLElement {
    constructor() {
      super();
      this.slides = Array.from(this.querySelectorAll('.shop-the-look__slide'));
      this.currentSlide = 0;
      this.prevButton = this.querySelector('[data-action="prev-slide"]');
      this.nextButton = this.querySelector('[data-action="next-slide"]');
      this.dotButtons = Array.from(this.querySelectorAll('[data-action="go-to-slide"]'));
      this.touchStartX = 0;
    }

    connectedCallback() {
      if (this.slides.length < 2) {
        this.querySelectorAll('.shop-the-look__arrow, .shop-the-look__dots').forEach((element) => {
          element.hidden = true;
        });
      }

      this.prevButton?.addEventListener('click', () => this.changeSlide(-1));
      this.nextButton?.addEventListener('click', () => this.changeSlide(1));
      this.dotButtons.forEach((button) => {
        button.addEventListener('click', () => {
          const index = Number(button.dataset.slideIndex);
          if (!Number.isNaN(index)) this.goToSlide(index);
        });
      });

      this.addEventListener('click', (event) => {
        const hotspot = event.target.closest('[data-action="select-product"]');
        if (!hotspot) return;
        event.preventDefault();
        this.selectProduct(hotspot);
      });

      this.addEventListener(
        'touchstart',
        (event) => {
          this.touchStartX = event.changedTouches[0].screenX;
        },
        { passive: true }
      );

      this.addEventListener(
        'touchend',
        (event) => {
          if (this.slides.length < 2) return;
          const touchEndX = event.changedTouches[0].screenX;
          const delta = touchEndX - this.touchStartX;
          if (Math.abs(delta) < 50) return;
          this.changeSlide(delta < 0 ? 1 : -1);
        },
        { passive: true }
      );

      this.resetActiveSlide();
    }

    changeSlide(direction) {
      if (this.slides.length < 2) return;
      const nextIndex = (this.currentSlide + direction + this.slides.length) % this.slides.length;
      this.goToSlide(nextIndex);
    }

    goToSlide(index) {
      if (index === this.currentSlide || !this.slides[index]) return;
      this.currentSlide = index;
      this.resetActiveSlide();
    }

    resetActiveSlide() {
      this.slides.forEach((slide, index) => {
        slide.classList.toggle('is-active', index === this.currentSlide);
        slide.toggleAttribute('hidden', index !== this.currentSlide);
      });

      this.dotButtons.forEach((button, index) => {
        const isActive = index === this.currentSlide;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-current', isActive ? 'true' : 'false');
      });

      const activeSlide = this.slides[this.currentSlide];
      if (!activeSlide) return;

      const firstHotspot = activeSlide.querySelector('[data-action="select-product"]');
      if (firstHotspot) this.selectProduct(firstHotspot);
    }

    selectProduct(hotspot) {
      const slide = hotspot.closest('.shop-the-look__slide');
      if (!slide || !slide.classList.contains('is-active')) return;

      const productIndex = hotspot.dataset.productIndex;
      slide.querySelectorAll('[data-action="select-product"]').forEach((button) => {
        button.classList.toggle('is-active', button === hotspot);
        button.setAttribute('aria-pressed', button === hotspot ? 'true' : 'false');
      });

      slide.querySelectorAll('.shop-the-look__product-card').forEach((card) => {
        const isActive = card.dataset.productIndex === productIndex;
        card.classList.toggle('is-active', isActive);
        card.toggleAttribute('hidden', !isActive);
      });
    }
  }

  customElements.define('shop-the-look-component', ShopTheLookComponent);
}
